module.exports = "img/taller-ing-1.297ffa.jpg";